export const SUPPORTED_SPORTS = {
  FOOTBALL: "football",
  HORSE_RACING: "horse-racing",
} as const;

export type SupportedSport =
  (typeof SUPPORTED_SPORTS)[keyof typeof SUPPORTED_SPORTS];

export const WIDGET_TYPES = {
  ACCA_FOOTBALL: "acca-football",
  ACCA_HORSE_RACING: "acca-horse-racing",
  PBB_FOOTBALL: "popular-bet-builder-football",
  PBB_HORSE_RACING: "popular-bet-builder-horse-racing",
} as const;

export type WidgetType = (typeof WIDGET_TYPES)[keyof typeof WIDGET_TYPES];

export const WIDGET_METADATA: Record<WidgetType, {
  sport: SupportedSport;
  requiresGtpMapping: boolean;
  eventIdParam: string;
}> = {
  [WIDGET_TYPES.ACCA_FOOTBALL]: {
    sport: SUPPORTED_SPORTS.FOOTBALL,
    requiresGtpMapping: false,
    eventIdParam: "fixtureId",
  },
  [WIDGET_TYPES.ACCA_HORSE_RACING]: {
    sport: SUPPORTED_SPORTS.HORSE_RACING,
    requiresGtpMapping: false,
    eventIdParam: "raceId",
  },
  [WIDGET_TYPES.PBB_FOOTBALL]: {
    sport: SUPPORTED_SPORTS.FOOTBALL,
    requiresGtpMapping: true,
    eventIdParam: "fixtureId",
  },
  [WIDGET_TYPES.PBB_HORSE_RACING]: {
    sport: SUPPORTED_SPORTS.HORSE_RACING,
    requiresGtpMapping: true,
    eventIdParam: "raceId",
  },
};

export const WidgetConfig = {
  ID_PREFIX: "sb-iframe-widget",
  PAGEVIEW_ANALYTICS_EVENT: "pageview",
  LOCALE_DEFAULT: "en-gb",
  LOCALE_ES: "es-es",
  CSS_CLASS: "sb-iframe-container",
} as const;

export const IframeConfig = {
  ID_PREFIX: "sb-iframe",
  MESSAGE_EVENT_TYPE: "message",
  PAGEVIEW_ANALYTICS_EVENT: "pageview",
  SOURCE: "william-hill",
  [WIDGET_TYPES.ACCA_FOOTBALL]: {
    URLS: {
      [WidgetConfig.LOCALE_DEFAULT]: process.env.IFRAME_SRC_ACCA_FOOTBALL,
      [WidgetConfig.LOCALE_ES]: process.env.IFRAME_SRC_ACCA_FOOTBALL_ES,
      TEST: process.env.IFRAME_SRC_ACCA_FOOTBALL_TEST,
    },
    SOURCE_ID: "popular-accas-football",
    HEADER_TITLE: "Popular Acca",
  },
  [WIDGET_TYPES.ACCA_HORSE_RACING]: {
    URLS: {
      [WidgetConfig.LOCALE_DEFAULT]: process.env.IFRAME_SRC_ACCA_HORSE,
      [WidgetConfig.LOCALE_ES]: process.env.IFRAME_SRC_ACCA_HORSE_ES,
      TEST: process.env.IFRAME_SRC_ACCA_HORSE_TEST,
    },
    SOURCE_ID: "popular-accas",
    HEADER_TITLE: "Popular Acca",
  },
  [WIDGET_TYPES.PBB_FOOTBALL]: {
    URLS: {
      [WidgetConfig.LOCALE_DEFAULT]: process.env.IFRAME_SRC_FOOTBALL,
      [WidgetConfig.LOCALE_ES]: process.env.IFRAME_SRC_FOOTBALL_ES,
      TEST: process.env.IFRAME_SRC_FOOTBALL_TEST,
    },
    SOURCE_ID: "popular-bet-builders",
    HEADER_TITLE: "Popular Bet Builders",
  },
  [WIDGET_TYPES.PBB_HORSE_RACING]: {
    URLS: {
      [WidgetConfig.LOCALE_DEFAULT]: process.env.IFRAME_SRC_HORSE,
      [WidgetConfig.LOCALE_ES]: process.env.IFRAME_SRC_HORSE_ES,
      TEST: process.env.IFRAME_SRC_HORSE_TEST,
    },
    SOURCE_ID: "popular-bet-builders-horseracing",
    HEADER_TITLE: "Popular Bet Builders",
  },
  HEADER_CSS_CLASS: "header-text",
  TIMESTAMP: 15_000,
  CSS_CLASS: "accasIframe",
} as const;

export const SpinnerConfig = {
  ID: "spinner",
  WRAPPER_ID: "spinner-wrapper",
} as const;

export const RetryConfigCOM = {
  BUTTON_TEXT: "Refresh",
  ERROR_TITLE: "Unexpected error occurred",
  ERROR_MESSAGE:
    "We are sorry but something went wrong. Please try refreshing.",
  CONTAINER_ID: "iframe-retry-container",
} as const;

export const RetryConfigES = {
  BUTTON_TEXT: "Actualizar",
  ERROR_TITLE: "Error inesperado ocurrido",
  ERROR_MESSAGE:
    "Lo sentimos, pero algo salió mal. Por favor, intente actualizar.",
  CONTAINER_ID: "iframe-retry-container",
} as const;
